'use client';
import { useState } from 'react';
import type { SupportAttachmentStatus } from '@/hooks/chat/useChat';

export function SupportAttachmentNotice({ status, onRetry }: { status: SupportAttachmentStatus; onRetry?: () => Promise<void> }) {
  const [retrying, setRetrying] = useState(false);
  const errorCopy = status.error === 'This support request has been closed.'
    ? 'This support request has been closed.'
    : status.error === 'This support request is unavailable.' || status.error === 'This conversation is unavailable.'
      ? 'This support request or conversation is no longer available.'
      : status.error ? 'The screenshots could not be attached. Please try again.' : undefined;
  const hasFailure = !!status.error || status.failed.length > 0;
  return <div role="status" className="mt-3 rounded-lg border border-gray-300 p-2 text-xs">
    <p>{hasFailure ? `Your support ticket was created, but ${status.failed.length ? status.failed.map(file => file.name).join(', ') : 'the screenshots'} could not be attached.` : `${status.attached_count} screenshot${status.attached_count === 1 ? '' : 's'} attached to your support ticket.`}</p>
    {errorCopy && <p>{errorCopy}</p>}
    {status.detail_path?.startsWith('/') && !status.detail_path.startsWith('//') && <a href={status.detail_path} className="mr-3 underline">View support ticket</a>}
    {hasFailure && onRetry && <button type="button" disabled={retrying} className="underline" onClick={async () => { setRetrying(true); try { await onRetry(); } finally { setRetrying(false); } }}>{retrying ? 'Attaching…' : 'Retry screenshots'}</button>}
  </div>;
}
